var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('abbr',{class:(_vm.relativeTimeClass + " relative-time__inner"),attrs:{"data-ticking":_vm.currentTime}},[(_vm.isResulted)?_c('span',[_vm._v("Resulted")]):_c('span',[_vm._v(_vm._s(_vm._f("countdownPunters")(_vm.targetTime)))])])}
var staticRenderFns = []

export { render, staticRenderFns }